<script setup lang="ts">
import { buttonColor, buttonSize, iconSize as textSize } from './Mappers'
import type { DefaultButton } from './types'

const { throttleTime = 1000, role = 'button' } = defineProps<
  DefaultButton & { throttleTime?: number }
>()

const emit = defineEmits<{
  (e: 'click', event: MouseEvent): void
}>()

const slot = useSlots()

const throttledClick = useThrottleFn((e: MouseEvent) => {
  emit('click', e)
}, throttleTime)
</script>
<template>
  <component
    :is="role === 'link' ? 'a' : 'button'"
    class="tw-daisy-btn"
    :class="[
      size ? buttonSize[size] : '',
      color ? buttonColor[color] : '',
      circle ? 'tw-daisy-btn-circle' : '',
      square ? 'tw-daisy-btn-square' : '',
    ]"
    @click="throttledClick"
  >
    <BtnLoading
      v-if="loading"
      :class="[`tw-daisy-loading-${iconSize || 'sm'}`]"
    />
    <span
      v-else-if="icon && !slot.icon"
      class="material-symbols-outlined"
      :class="[
        iconSize ? textSize[iconSize] : '',
        spin ? 'tw-animate-spin' : '',
        iconColor,
      ]"
      translate="no"
    >
      {{ icon }}
    </span>
    <slot v-else name="icon" />
    {{ label }}
  </component>
</template>
